import axiosStatic, { HttpStatusCode } from 'axios'
import { attach, getConfig, shouldRetryRequest } from 'retry-axios'
import logger from '@shared/logger.js'

axiosStatic.defaults.withCredentials = true

const axios = axiosStatic.create({
  baseURL: import.meta.env.VITE_API_BASE_URL,
  xsrfCookieName: 'csrftoken',
  xsrfHeaderName: 'X-CSRFToken'
})

if (import.meta.env.VITE_BUILD_TIME) {
  axios.defaults.headers.common['APP-BUILD-TIME'] = import.meta.env.VITE_BUILD_TIME
}

axios.defaults.raxConfig = {
  instance: axios,
  shouldRetry: (err) => {
    if (err.response?.status === HttpStatusCode.InternalServerError) {
      return false
    }
    return shouldRetryRequest(err)
  },
  onRetryAttempt: (err) => {
    const cfg = getConfig(err)
    logger.debug(`Retry attempt #${cfg.currentRetryAttempt}`)
  }
}
attach(axios)

axios.interceptors.response.use(
  (response) => response,
  (error) => {
    // Client is out of date (extremely unlikely).
    // Force a reload to get the latest app version.
    if (error.response?.status === HttpStatusCode.BadRequest &&
      error.response.data?.startsWith?.('Client upgrade required')) {
      setTimeout(() => { location.reload() }, 5000)
    }
    throw error
  }
)

if (window.armoireAppUserInfo?.authToken) {
  axios.defaults.headers.common.Authorization = `KToken ${window.armoireAppUserInfo.authToken}`
}

export default axios
